<template>
  <div
      v-on:keyup.13="$emit('choose-item', filtered_items[idx_selected])"
      class="position-relative"
      >
    <b-form-input autocomplete="off"
      v-on:keyup.40.native="change_idx(1)"
      v-on:keyup.38.native="change_idx(-1)" 
      v-model="input.value" 
      :id="input.id"
      :class="(input.has_error) ? 'is-invalid' : ''" class="text-capitalize" :placeholder="input.placeholder">
    </b-form-input>
    <small v-if="input.has_error" class="text-danger">{{input.error}}</small>
    <div class="wrapper-suggestions position-absolute" v-show="show && filtered_items.length > 0">
      <div class="p-2">
        <p v-for="(f_item, idx) in filtered_items" :key="idx" :class="[(idx === idx_selected) ? 'selected-suggestion' : '', (input.has_error) ? 'is-invalid' : '']" v-on:click="$emit('choose-item', f_item)" class="pl-2 pr-2 pt-1 pb-1 cursor-pointer suggestion d-block">
          {{f_item.name}}
        </p>
      </div>
    </div>
  </div>
</template> 

<script>
  export default {
    props: ["items", 'key_compare', 'input', 'show'],
    data() {
      return {
        idx_selected: 0,
        start_idx: 0,
        show_box: this.show
      }
    }, 
    methods: {
      change_idx: function(pos_to) {
        if(typeof this.filtered_items[this.idx_selected+pos_to] !== 'undefined') {
          this.idx_selected += pos_to;
        }
      },
      /*get_item: function() {
        let res = this.items.find((item, idx) => item[this.key_compare].toLowerCase() == this.input.value.toLowerCase());
        console.log(res);
      }*/
    },
    computed: {
      filtered_items: function() {
        this.idx_selected = this.start_idx;
        if(this.input.value.trim() !== '')
          return this.items.filter((val, idx) => val[this.key_compare].toLowerCase().indexOf(this.input.value.toLowerCase().trim()) !== -1);
        return [];
      }
    },
  }
</script>
<style scoped>
  .wrapper-suggestions > div {
    max-height: 250px;
    width: 100%;
    border-radius: 0.25rem;
    -webkit-box-shadow: 0px 2px 26px -5px rgba(0,0,0,0.75);
    -moz-box-shadow: 0px 2px 26px -5px rgba(0,0,0,0.75);
    box-shadow: 0px 2px 26px -5px rgba(0,0,0,0.75);
    background-color: #ffffff;
    overflow-x: hidden;
    overflow-y: scroll;
  }
  .wrapper-suggestions {
    z-index: 9999;
    width: 100%;
  }
  .suggestion {
    margin: 0;
    border-radius: 0.25rem;
  }
  .suggestion:hover {
    background-color: #20a8d8;
    color: #ffffff;
  }
  .selected-suggestion {
    background-color: #20a8d8;
    color: #ffffff;
  }
</style>